import { render, staticRenderFns } from "./QR.vue?vue&type=template&id=163b68b7&"
import script from "./QR.vue?vue&type=script&lang=js&"
export * from "./QR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports